import { useFetchCallType } from '@rahtab/auth/lib/token-based-auth';

const useOfficialBillRequest = (billCode: string) => {
  const [request, { loading, data }] = useFetchCallType<ServerResponse>('OfficialFactorRequest', {
    params: `FactorCode=${billCode}`,
    skip: true,
  });
  return { request, loading, data };
};

export default useOfficialBillRequest;

interface ServerResponse {
  result: boolean;
  error: string;
  message: string;
}
